import { useEffect, useState } from "react";
import { Layers } from "lucide-react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

// Roll sqft position (received / consumed / balance) per studio × product type, from serial records.
export const RollStockSummary = ({ studioId }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const q = studioId && studioId !== "all" ? `?studio_id=${studioId}` : "";
    api.get(`/roll-serials/stock-summary${q}`).then(({ data }) => setRows(data || [])).catch(() => setRows([]));
  }, [studioId]);

  if (!rows.length) return null;

  return (
    <Card className="mb-6 border-brand-line shadow-none" data-testid="roll-stock-summary">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Layers className="h-4 w-4 text-brand" /> PPF / Sunfilm roll stock (sqft)
        </CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-auto p-0">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs text-slate-500">
            <tr>
              <th className="p-2">Studio</th>
              <th className="p-2">Product</th>
              <th className="p-2 text-right">Rolls</th>
              <th className="p-2 text-right">Received</th>
              <th className="p-2 text-right">Consumed</th>
              <th className="p-2 text-right">Balance</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className="border-t border-brand-line" data-testid="roll-stock-row">
                <td className="p-2">{r.studio_name || "—"}</td>
                <td className="p-2">{r.product_type}</td>
                <td className="p-2 text-right">{r.rolls}</td>
                <td className="p-2 text-right">{Math.round(r.received_sqft)}</td>
                <td className="p-2 text-right">{Math.round(r.consumed_sqft)}</td>
                <td className="p-2 text-right font-semibold">{Math.round(r.balance_sqft)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
};
